var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/compose/components/emoji-picker/modifier-picker-menu.tsx";
import { supportsPassiveEvents } from 'detect-passive-events';
import React, { useCallback, useEffect, useRef } from 'react';
import { Emoji } from './emoji-picker-dropdown';
const listenerOptions = supportsPassiveEvents ? {
  passive: true
} : false;

const backgroundImageFn = () => require('emoji-datasource/img/twitter/sheets/32.png');

const ModifierPickerMenu = _ref => {
  let {
    active,
    onSelect,
    onClose
  } = _ref;
  const node = useRef(null);

  const handleClick = e => {
    onSelect(+e.currentTarget.getAttribute('data-index') * 1);
  };

  const handleDocumentClick = useCallback(e => {
    if (node.current && !node.current.contains(e.target)) {
      onClose();
    }
  }, []);

  const attachListeners = () => {
    document.addEventListener('click', handleDocumentClick, false);
    document.addEventListener('touchend', handleDocumentClick, listenerOptions);
  };

  const removeListeners = () => {
    document.removeEventListener('click', handleDocumentClick, false);
    document.removeEventListener('touchend', handleDocumentClick, listenerOptions);
  };

  useEffect(() => {
    return () => {
      removeListeners();
    };
  }, []);
  useEffect(() => {
    if (active) attachListeners();else removeListeners();
  }, [active]);
  return /*#__PURE__*/React.createElement("div", {
    className: "emoji-picker-dropdown__modifiers__menu",
    style: {
      display: active ? 'block' : 'none'
    },
    ref: node,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    "data-index": 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: 1,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    "data-index": 2,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: 2,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    "data-index": 3,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: 3,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    "data-index": 4,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: 4,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    "data-index": 5,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: 5,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 64,
      columnNumber: 9
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleClick,
    "data-index": 6,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 66,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Emoji, {
    emoji: "thumbsup",
    set: "twitter",
    size: 22,
    sheetSize: 32,
    skin: 6,
    backgroundImageFn: backgroundImageFn,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 67,
      columnNumber: 9
    }
  })));
};

export default ModifierPickerMenu;